import React, { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const ConfirmationModal = ({
  prompt,
  onConfirm,
  onCancel,
  checkBox,
  openTermsModal,
  showDiscountInput = false, // ✅ NEW
  discountErrorMessage = "", // ✅ NEW
}) => {
  const [showCheckbox, setShowCheckbox] = useState(checkBox);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [attemptedConfirmWithoutCheck, setAttemptedConfirmWithoutCheck] =
    useState(false);

  const [discountCode, setDiscountCode] = useState(""); // ✅ NEW

  const handleConfirmClick = () => {
    if (showCheckbox && !isCheckboxChecked) {
      setAttemptedConfirmWithoutCheck(true);
      return;
    }
    // Pass discountCode to parent (may be "")
    onConfirm(discountCode.trim() || null); // ✅ pass code up
  };

  const handleCheckboxChange = (event) => {
    setIsCheckboxChecked(event.target.checked);
    if (event.target.checked) {
      setAttemptedConfirmWithoutCheck(false);
    }
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center z-50">
      <div className="absolute inset-0 bg-black opacity-50 backdrop-blur-sm"></div>
      <div className="relative bg-white rounded-3xl shadow-lg p-4 w-96 z-100">
        <h2 className="text-lg font-semibold m-2">{prompt}</h2>

        {/* ✅ Optional discount code input */}
        {showDiscountInput && (
          <div className="m-2">
            <label className="block text-sm font-medium mb-1">
              Alennuskoodi (valinnainen)
            </label>
            <input
              type="text"
              value={discountCode}
              onChange={(e) => {
                // allow letters, digits, dashes; tweak if needed
                setDiscountCode(e.target.value);
              }}
              placeholder="Syötä alennuskoodi"
              className="w-full rounded-lg border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-600"
            />
            {!!discountErrorMessage && (
              <p className="text-red-600 text-sm mt-1">
                {discountErrorMessage}
              </p>
            )}
          </div>
        )}

        <div className="flex flex-col justify-center">
          <div className="flex flex-row justify-center">
            <button
              className="bg-teal-600 text-white rounded-lg p-2 w-24 m-2 hover:bg-teal-700"
              onClick={handleConfirmClick}
            >
              Kyllä
            </button>
            <button
              className="bg-red-600 text-white rounded-lg p-2 w-24 m-2 hover:bg-red-700"
              onClick={onCancel}
            >
              Ei
            </button>
          </div>

          {showCheckbox && (
            <FormGroup>
              <FormControlLabel
                required
                control={
                  <Checkbox
                    checked={isCheckboxChecked}
                    onChange={handleCheckboxChange}
                  />
                }
                label={
                  <span
                    className={`${
                      attemptedConfirmWithoutCheck
                        ? "text-red-500"
                        : "text-black"
                    }`}
                  >
                    Olen lukenut{" "}
                    <span
                      className="text-blue-500 cursor-pointer hover:underline"
                      onClick={openTermsModal}
                    >
                      käyttöehdot
                    </span>{" "}
                    ja hyväksyn ne
                  </span>
                }
              />
            </FormGroup>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
